import * as queryString from 'query-string';
import config from '../../config';
import { getNewClubPath } from './clubs';

export function getReferralUrl(referralCode) {
    return `${config.appHost}/referral/${referralCode}`;
}

export function getClubReferralURL(clubDetails, currentUser, clubRedirectsEnabled) {
    const clubMemberRole = clubDetails.currentMember
        ? clubDetails.currentMember.role : '';
    const clubTierTypeId = clubDetails.tierTypeId || clubDetails.tierType?.id;
    const newClubPath = getNewClubPath(clubTierTypeId);

    // Owners and Admins share the club referral code
    if (clubMemberRole === 'Owner' || clubMemberRole === 'Admin') {
        if (clubRedirectsEnabled && clubTierTypeId) {
            return `${config.nextAppHost}/${newClubPath}/${clubDetails.id}?_ref=${clubDetails.referralCode}`;
        }
        return `${config.appHost}/clubs/${clubDetails.id}?_ref=${clubDetails.referralCode}`;
    }
    // regular users share their own referral code
    if (clubRedirectsEnabled && clubTierTypeId) {
        return `${config.nextAppHost}/${newClubPath}/${clubDetails.id}?_ref=${currentUser.referralCode}`;
    }
    return `${config.appHost}/clubs/${clubDetails.id}?_ref=${currentUser.referralCode}`;
}

export function getClubInviteURL(clubDetails, user, referralsEnabled, clubRedirectsEnabled) {
    if (!clubDetails || !user) {
        return '';
    }

    if (referralsEnabled) {
        return getClubReferralURL(clubDetails, user, clubRedirectsEnabled);
    }

    const clubTierTypeId = clubDetails.tierTypeId || clubDetails.tierType?.id;
    if (clubRedirectsEnabled && clubTierTypeId) {
        const newClubPath = getNewClubPath(clubTierTypeId);
        return `${config.nextAppHost}/${newClubPath}/${clubDetails.id}`;
    }

    return `${config.appHost}/clubs/${clubDetails.id}`;
}

export function getEventReferralURL(eventDetails, currentUser) {
    const clubMemberRole = eventDetails.currentMember &&
             eventDetails.currentMember.clubMemberRole
        ? eventDetails.currentMember.clubMemberRole.value : '';

    if (clubMemberRole === 'Owner' || clubMemberRole === 'Admin') {
        return `${config.appHost}/events/${eventDetails.id}?_ref=${eventDetails.club.referralCode}&shared=true`;
    }
    return `${config.appHost}/events/${eventDetails.id}?_ref=${currentUser.referralCode}&shared=true`;
}

export function getEventShareURL(eventDetails) {
    return eventDetails ? `${config.appHost}/events/${eventDetails.id}?shared=true` : '';
}

export function getHSClaimReferralUrl(referralCode) {
    return `${config.appHost}/hsclub?_ref=${referralCode}`;
}

export function parseReferralCode(url) {
    const parsed = queryString.parse(url);
    if ('_ref' in parsed) {
        return {
            // eslint-disable-next-line no-underscore-dangle
            code: parsed._ref,
            refSrc: parsed.refSrc,
        };
    }
    return false;
}
